import { __generator } from "tslib";
import ddt from '@wix/da-ddt';
import { getCookiePrivacyRequired, getCookieSettings, getHasAcceptedCookies, } from '../../publicSession/selectors';
import { setCompliantLocalStorageItem, removeCompliantLocalStorageItem, } from './actions';
import { verifyAccessToLocalStorage, getStorageEventChannel } from './utils';
import { takeEvery, all, select } from 'redux-saga/effects';
import localStorageWrapper from '../../utils/localStorageWrapper';
import { appMounted } from '../../redux/app/actions';
export function setCompliantLocalStorageHandler(action) {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = verifyAccessToLocalStorage;
                _b = [action.payload.key];
                return [4 /*yield*/, select(getCookiePrivacyRequired)];
            case 1:
                _b = _b.concat([_c.sent()]);
                return [4 /*yield*/, select(getHasAcceptedCookies)];
            case 2:
                _b = _b.concat([_c.sent()]);
                return [4 /*yield*/, select(getCookieSettings)];
            case 3:
                if (_a.apply(void 0, _b.concat([_c.sent()]))) {
                    ddt.log('compliantlocalstorage', "writing key: ".concat(action.payload.key, " to localStorage with value of: ").concat(action.payload.value));
                    localStorageWrapper.setItem(action.payload.key, action.payload.value || '');
                }
                return [2 /*return*/];
        }
    });
}
export function appMountedHandler() {
    var handler;
    return __generator(this, function (_a) {
        handler = function (event) { return getStorageEventChannel().put(event); };
        window.addEventListener('storage', handler);
        return [2 /*return*/, function () {
                window.removeEventListener('storage', handler);
            }];
    });
}
function removeCompliantLocalStorageHandler(action) {
    var key, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                key = action.payload.key;
                _a = verifyAccessToLocalStorage;
                _b = [key];
                return [4 /*yield*/, select(getCookiePrivacyRequired)];
            case 1:
                _b = _b.concat([_c.sent()]);
                return [4 /*yield*/, select(getHasAcceptedCookies)];
            case 2:
                _b = _b.concat([_c.sent()]);
                return [4 /*yield*/, select(getCookieSettings)];
            case 3:
                if (_a.apply(void 0, _b.concat([_c.sent()]))) {
                    ddt.log('compliantlocalstorage', "removing key: ".concat(key));
                    localStorageWrapper.removeItem(key);
                }
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(appMounted, appMountedHandler),
                    takeEvery(setCompliantLocalStorageItem, setCompliantLocalStorageHandler),
                    takeEvery(removeCompliantLocalStorageItem, removeCompliantLocalStorageHandler),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map